// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center {\n    text-align: center;\n}\n\n.displayAddressDiv {\n    vertical-align: top;\n    padding-bottom: 0.5em;\n}\n\n.displayAddressDiv .displayAddressUL {\n    list-style-type: none;\n    padding: 0%;\n    margin-left: 0%;\n    margin-top: 0%;\n    margin-bottom: 0%;\n    vertical-align: top;\n}\n\n.displayAddressDiv .displayAddressLI {\n    width: 100%;\n}", ""]);
// Exports
module.exports = exports;
